<template>
	<div :style="mainStyle" class="wrapper">
		<el-tabs class="box-card" v-model="activeName" :stretch="true" type="border-card">
			<el-tab-pane label="重置密码" name="forgetPassword" class="tab-panel">
				<el-form class="active-form" :hide-required-asterisk="true"
								 :model="forgetPasswordForm"
								 :rules="rules"
								 v-loading="loading"
								 ref="forgetPasswordForm">
					<el-form-item label="请输入用户手机号码" prop="username">
						<el-input v-model="forgetPasswordForm.username" placeholder="请输入您的手机号码"></el-input>
					</el-form-item>
					<el-form-item label="请输入密码" prop="password">
						<el-input v-model="forgetPasswordForm.password" type="password"  placeholder="请输入密码"></el-input>
					</el-form-item>
					<el-form-item label="请再次输入密码" prop="passwordAg">
						<el-input v-model="forgetPasswordForm.passwordAg" type="password" placeholder="请再次输入密码"></el-input>
					</el-form-item>
					<el-form-item label="请输入验证码" prop="code" class="login-code-item" >
						<el-input v-model="forgetPasswordForm.code" placeholder="请输入验证码">
							<template>
								<template slot="append">
									<el-button @click="getLoginCode" class="code-btn" :disabled="codeBtnDisabled">{{loginCodeMsg}}</el-button>
								</template>
							</template>
						</el-input>
					</el-form-item>
					<el-button class="login-btn" type="primary" @click="forgetPassword('forgetPasswordForm')">确定</el-button>
				</el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import config from "../../config/global.js";
	var getCodeUrl = config.host+"/backend/getusercode.json";
	var forgetPasswordUrl = config.host+"/backend/updatepwdcode.json";
    export default {
      name: "active-password",
			data:function () {
				var samePasswordValidator = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入密码'));
					} else {
						if (this.forgetPasswordForm.passwordAg !== '') {
							this.$refs.forgetPasswordForm.validateField('passwordAg');
						}
						callback();
					}
				};
				var samePasswordValidatorAg = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请再次输入密码'));
					} else if (value !== this.forgetPasswordForm.password) {
						callback(new Error('两次输入密码不一致!'));
					} else {
						callback();
					}
				};
				return {
					mainStyle:{"width":'100%',"height":window.innerHeight+"px","display":"flex","justify-items":"center","align-items":"center"},
					activeName:"forgetPassword",
					forgetPasswordForm: {
						password: "",
						passwordAg:"",
						username:"",
						code:"",
					},
					loading: false,
					fetching:false,
					loginCodeMsg:"获取验证码",
					codeBtnDisabled:false,
					rules: {
						username: [
							{ required: true, message: '请输入用户名', trigger: 'blur' }
						],
						code: [
							{ required: true, message: '请输入验证码', trigger: 'blur' }
						],
						password: [
							{ validator: samePasswordValidator, trigger: 'blur' }
						],
						passwordAg: [
							{ validator: samePasswordValidatorAg, trigger: 'blur' }
						],
					},
				}
			},
			methods:{
				forgetPassword:function (formName) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.loading=true;
							var params = {"phone":this.forgetPasswordForm.username,"code":this.forgetPasswordForm.code,"newpwd":this.forgetPasswordForm.password};
							this.$http.post(forgetPasswordUrl,params).then(
								function(response){
									var defaultResult = this.responseDefaultHandle(response);
									if(defaultResult == false )
										return;
									var res = response.body;
									if(res.result==1){
										this.$message({
											message: "您的密码已重置",
											type: "success"
										});
										var userInfo = {};
										userInfo.name = res.name;
										userInfo.orgname = res.orgname;
										userInfo.phone = res.phone;
										userInfo.type = res.type;
										this.$store.commit("setUserInfo",userInfo);
										this.$router.replace({"name":"index"});
									}else{
										this.$message.error(res.emsg);
									}
									this.loading=false;
								},function(){
									this.$message.error("重置密码失败");
									this.loading=false;
								})
						} else {
							return false
						}
					})
				},
				getLoginCode:function () {
					if(this.forgetPasswordForm.username == ""){
						this.$message.error("手机号码不能为空");
						return;
					}
					if(this.loading == false && this.fetching == false ){
						this.fetching = true;
						this.loading == true;
						var params = {"phone":this.forgetPasswordForm.username,"type":3};
						this.$http.post(getCodeUrl,params).then(
							function(response){
								var res = response.body;
								this.buildCodeMsg();
								if(res.result==1){
									this.$message({
										message: "验证码已发送",
										type: "success"
									});
								}else{
									this.$message.error(res.emsg);
								}
								this.loading=false;
								this.fetching = false;
							},function(){
								this.$message.error("获取验证码失败");
								this.loading=false;
								this.fetching = false;
							})
					}
				},
				buildCodeMsg:function () {
					var cSecond = 60;
					this.loginCodeMsg = "重新发送("+cSecond+")";
					if(this.timer != null)
						clearInterval(this.timer);
					this.codeBtnDisabled = true;
					var _this = this;
					this.timer = setInterval(function(){
						cSecond--;
						_this.loginCodeMsg = "重新发送("+cSecond+")";
						if(cSecond == 0){
							_this.loginCodeMsg = "获取验证码";
							_this.fetching = false;
							_this.codeBtnDisabled = false;
							clearTimeout(_this.timer);
						}
					},1000);
				},
			}
    }
</script>

<style scoped>
	.wrapper>>>.el-card__body{
		padding: 0px;
	}

	.wrapper>>>.el-form-item__label{
		color: rgb(175, 175, 175);
		font-size: 13px;
		font-weight: 400;
	}
	.wrapper>>>.el-tabs__item.is-top{
		line-height: 50px;
		height: 50px;
		font-size: 18px;
	}
	.wrapper>>>.el-tabs__content{
		padding: 15px 25px;
	}

	.wrapper>>>.el-form-item{
		margin-bottom: 0px;
	}

	.wrapper>>>.el-input__inner{
		border: 1px solid #eaeff1;
		background: #fbfbfb;
		box-shadow: none;
		border-radius: 3px;
		height: 40px;
		font-size: 12px;
		padding: 4px 16px;
	}

	.wrapper>>>.el-input__inner:focus{
		border-color: #409EFF;
		outline: 0;
		box-shadow: 0 0 8px #409EFF;
	}

	.wrapper>>>.el-form-item.is-error .el-input__inner{
		border-color: #F56C6C;
		box-shadow: 0 0 8px #F56C6C;
	}

	.wrapper>>>.el-form-item__error{
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		position: absolute;
		top: 40px;
		right: 10px;
		line-height: 40px;
		padding-top: 0px;
		left: inherit;
	}

	.wrapper>>>.login-code-item .el-form-item__error {
		right: 130px;
	}

	.box-card{
		width:450px;
		height: 520px;
		margin: -100px auto 0 auto;
		border-radius: 0 0 5px 5px;
	}
	.title{
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
		font-size: 22px;
		text-align: center;
		margin: 20px auto 30px ;
	}
	.error{
		text-align: center;
		color: red;
		margin: -10px 0 10px 0;
	}

	.tab-panel{
		width: 100%;
		height: 100%;
	}

	.login-form{
		width: 100%;
		height: 280px;
	}

	.login-btn{
		width: 100%;
		margin-top: 40px;
	}

	.code-btn{
		width: 125px;
		font-size: 13px;
	}

	.el-button.is-disabled{
		color: #C0C4CC;
		cursor: not-allowed;
		background-image: none;
		background-color: #FFF;
		border-color: #EBEEF5;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ForgetPassword.vue